import { gql } from '@apollo/client'

export const UPDATE_SUBSCRIPTION_UNIT_QUANTITY = gql`
  mutation UpdateSubscriptionUnitQuantity(
    $input: UpdateSubscriptionUnitQuantityInput!
  ) {
    updateSubscriptionUnitQuantity(input: $input) {
      success
      subscriptionId
      quantity
    }
  }
`
